import React from 'react';
import { graphql } from 'gatsby';
import { BlogPage } from 'gatsby-theme-shopify-poulo';

const BlogPostTemplate = ({ data }) => {
  return <BlogPage data={data}></BlogPage>;
};

export default BlogPostTemplate;

export const pageQuery = graphql`
  query blogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      fields {
        slug
      }
      excerpt(pruneLength: 160)
      html
      frontmatter {
        url
        title
        date(formatString: "MMMM DD, YYYY")
        description
        topics
        thumbnail {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              aspectRatio: 1
              width: 400
              placeholder: DOMINANT_COLOR
              formats: [WEBP, AUTO]
              breakpoints: [400]  # 响应式断点
              outputPixelDensities: [0.5, 1]  # 降低高DPI设备密度
            )
          }
        }
      }
    }
  }
`;
